export interface JWTPayload {
  org?: string;
  jobber_account?: {
    id?: string;
    name?: string;
  };
  typ?: string;
  exp?: number;
  iat?: number;
  iss?: string;
  [key: string]: any;
}

export function decodeJWT(token: string): JWTPayload | null {
  try {
    const parts = token.split(".");
    if (parts.length !== 3) {
      console.error(
        "[JWT] Invalid token format - expected 3 parts, got",
        parts.length,
      );
      return null;
    }

    const payload = parts[1];
    const decoded = atob(payload.replace(/-/g, "+").replace(/_/g, "/"));
    const parsed = JSON.parse(decoded);

    return parsed;
  } catch (error) {
    console.error("[JWT] Failed to decode token:", error);
    return null;
  }
}

export function getTokenType(token: string): "access" | "refresh" | "unknown" {
  const payload = decodeJWT(token);
  if (!payload) return "unknown";

  if (payload.typ === "access") return "access";
  if (payload.typ === "refresh") return "refresh";

  return "unknown";
}

export function isTokenExpired(token: string): boolean {
  const payload = decodeJWT(token);
  if (!payload || !payload.exp) return true;

  const now = Math.floor(Date.now() / 1000);
  return payload.exp < now;
}

export function getTokenDebugInfo(token: string, name: string): string {
  const payload = decodeJWT(token);
  const tokenType = getTokenType(token);
  const expired = isTokenExpired(token);

  return `[${name}] type: ${tokenType}, org: ${payload?.org || "none"}, expired: ${expired}, length: ${token.length}, preview: ${token.substring(0, 20)}...`;
}
